import React from "react";
import { useSelector } from "react-redux";

const hasHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

const About = () => {
  const { currentEvent } = useSelector((state) => state);
  const description = currentEvent?.fullDescription;

  if (!description || description.length === 0) return null;

  const isHTML = hasHTML(description);

  return (
    <div style={{ marginTop: "20px" }}>
      {isHTML ? (
        <div dangerouslySetInnerHTML={{ __html: description }} />
      ) : (
        description.split('\n').map((line, index) => (
          <p key={index}>{line}</p>
        ))
      )}
    </div>
  );
};

export default About;